import React, { useContext, useEffect, useState } from "react";
import { find, get, isEmpty } from "lodash";
import { Form, Tabs, Tab, Modal, Button } from "react-bootstrap";
import { faTimes, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import {
  faPencilAlt,
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/pro-light-svg-icons";
import { Formik } from "formik";
import {
  ManagePlanLayout,
  LoaderWrapper,
  DeleteWarning,
  AccountBalanceComponent,
} from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  getSaveMessage,
  getAdvancedPathWithParam,
} from "../../../utils";
import {
  createPlanStore,
  setManagePlanToastInfo,
  clearLocalCacheByModel,
} from "../../../contexts";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import BasicDetails from "./BasicDetails/BasicDetails";
import ClearingPartnerDetails from "./ClearingPartnerDetails/ClearingPartnerDetails";
import AdvisorRepresentativeDetails from "./AdvisorRepresentative/AdvisorRepresentativeDetails";
import investmentTabGroupPlan from "../../../mocks/investmentTabGroupPlan.json";
import {
  deleteInvestment,
  getInvestment,
  getPlanInvestmentData,
  listInvestment,
  saveInvestment,
} from "../../../services";

const initialValues = {
  alias: null,
  //custodianId: null,
  excludeInvestmentFrom: null,
  trusteeId: null,
  dividendProcessingFrequency: null,
  dividendProcessingOption: 2,
  applicableTypes: [],
  clearanceTime: [],
  //HardCoded for demo
  // custodianId: 1,
  // custodianAccountId: 1,
  // clearanceTime: [1],
  // excludeInvestmentFrom: [1],
};

const AddInvestmentContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const { planId, flow, investmentId } = useRouterParams();
  const [toggle, setToggle] = useState(true);
  const [newFlow, setNewFlow] = useState(
    flow != FLOW_TYPES.SAVE ? FLOW_TYPES.EDIT : FLOW_TYPES.SAVE
  );
  const [isModalOpen, setIsModalOpen] = useState(0);
  const handleClose = () => {
    setIsModalOpen(false);
  };
  const formName = managePlanFormNames.ADD_INVESTMENT;
  const fields = formFields[formName];
  const [investmentsData, setInvestmentsData] = useState([]);
  useDeepEffect(() => {
    listInvestment(planId).then((response) => {
      setInvestmentsData(response.investmentPlanMappings);
    });
  }, []);
  // const investmentsData = get(apiData, "investments", []);
  const intInvestmentId = parseInt(investmentId, 10);
  const [showWarning, setShowWarning] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const { response: investment, loading: getLoading } = useRequest({
    method: getInvestment,
    payload: investmentId,
    defaultResponse: {},
  });
  const formValues = get(investment, "investment", {});
  const type = get(formValues, "type", null);
  const restrictionsList = get(formValues, "restrictions", []);
  const [keyValue, setKeyValue] = useState(1);
  const DeleteToastMessageHead = "Delete Investment?";
  const DeleteToastMessage = "You are attempting to delete investment.";
  const tabChange = (key) => {
    setKeyValue(key);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [restrictions, setRestrictions] = useState(
    get(formValues, "restrictions", [])
  );
  const tabGroups = investmentTabGroupPlan;
  const [isInnerFormDirty, setIsInnerFormDirty] = useState(false);
  const [saveTriggered, setSaveTriggered] = useState(false);
  const [tabColors, setTabColors] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });
  // useEffect(() => {
  //   setIsLoading(true);
  //   getPlanInvestmentData(intInvestmentId)
  //     .then((response) => {
  //       setIsLoading(false);
  //       setFormValues(response);
  //     })
  //     .catch((ex) => {
  //       setIsLoading(false);
  //     });
  // }, []);
  const [tabColorGrey, setTabColorGrey] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });

  const onDeleteClick = () => {
    setShowWarning(true);
  };

  const handleCancelClick = () => {
    setShowWarning(false);
  };

  const handleConfirmClick1 = () => {
    setShowWarning(false);

    deleteInvestment(intInvestmentId).then((response) => {
      if (response.isSuccessful) {
        dispatch(clearLocalCacheByModel("investments"));
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data Deleted Successfully",
          })
        );
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.MANAGE_INVESTMENTS_PLAN,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
      }
    });
  };

  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.MANAGE_INVESTMENTS_PLAN,
        pathParam: [FLOW_TYPES.EDIT, planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => {
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ADD_INVESTMENTS,
            pathParam: [FLOW_TYPES.SAVE, planId, intInvestmentId],
          })
        );
        setNewFlow(FLOW_TYPES.SAVE);
      },
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      //icon: faTrashAlt,
      onClick: onDeleteClick,
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];

  const getDataForSave = (values) => {
    const {
      alias,
      trusteeId,
      custodianId,
      custodianAccountId,
      excludeInvestmentFrom,
      clearanceTime,
      dividendProcessingOption,
      ...filteredValues
    } = values;

    const updatedValues = {
      ...filteredValues,
      planId: planId,
      restrictions: restrictions,
      planInvestment:
        type != 1
          ? {
              alias,
              trusteeId,
              custodianId,
              //custodianAccountId,
              excludeInvestmentFrom,
              clearanceTime,
              dividendProcessingOption,
            }
          : null,
    };
    if (isEmpty(formValues)) {
      return [...investmentsData, updatedValues];
    }
    var updatedInvestmentsData = investmentsData.map((item) => {
      if (item.id === intInvestmentId) {
        return { ...item, ...updatedValues };
      }
      return item;
    });
    return updatedInvestmentsData.find((_) => _.id == intInvestmentId);
  };

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    setIsLoading(true);
    setSaveTriggered(true);
    setTabColorGrey({ 1: false, 2: false, 3: false, 4: false, 5: false });
    const { history } = props;
    saveInvestment(getDataForSave(values)).then((response) => {
      setIsLoading(false);

      if (response.isSuccessful) {
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data Saved Successfully",
          })
        );
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.MANAGE_INVESTMENTS_PLAN,
            pathParam: [FLOW_TYPES.EDIT, planId],
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: getSaveMessage(
              investmentId,
              `New Investment ${values[fields.investmentName]} has been created`
            ),
          })
        );
      } else {
        setSubmitting(false);
        var color = { 1: false, 2: false, 3: false, 4: false, 5: false };
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          var x = [tabGroups[_.controlName]];
          x == 1
            ? (color[1] = true)
            : x == 2
            ? (color[2] = true)
            : x == 3
            ? (color[3] = true)
            : x == 4
            ? (color[4] = true)
            : x == 5 && (color[5] = true);
        }
        setTabColors(color);
      }
    });
  };

  const isEdit = newFlow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  const layoutHeader = investmentId && "Investment";

  const setTabGrey = (tab) => {
    tab == 1
      ? (tabColorGrey[1] = true)
      : tab == 2
      ? (tabColorGrey[2] = true)
      : tab == 3
      ? (tabColorGrey[3] = true)
      : tab == 4
      ? (tabColorGrey[4] = true)
      : tab == 5 && (tabColorGrey[5] = true);

    setTabColorGrey(tabColorGrey);
  };

  const setTabColor = (tabValue) => {
    return tabColorGrey[tabValue] && !saveTriggered
      ? "grey"
      : saveTriggered
      ? tabColors[tabValue]
        ? "red"
        : "green"
      : "green";
  };

  const setTabClass = (tabValue) => {
    return keyValue == tabValue
      ? "active"
      : saveTriggered
      ? tabColors[tabValue]
        ? "error"
        : "green"
      : "";
  };

  const setTabIcon = (tabValue) => {
    return tabColors[tabValue] == true ? faExclamationTriangle : faCheckCircle;
  };

  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
        ...get(formValues, "planInvestment", {}),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          setFieldError,
          fieldValue,
          ...rest
        } = formProps;

        return (
          <LoaderWrapper isLoading={isLoading || getLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout
                buttons={buttons}
                pageFlow={newFlow || flow}
                layoutHeader={layoutHeader}
              >
                <div className="tab-width">
                  <div className="addInvestment-tabs-head">
                    {type == 1 ? (
                      <Tabs
                        activeKey={keyValue}
                        transition={false}
                        onSelect={tabChange}
                        mountOnEnter
                        unmountOnExit
                      >
                        <Tab
                          eventKey={1}
                          title={
                            <div>
                              <FontAwesomeIcon
                                icon={setTabIcon(1)}
                                color={setTabColor(1)}
                                className={"mr-1"}
                              />
                              <span className="tabName">Basic Details</span>
                            </div>
                          }
                          tabClassName={setTabClass(1)}
                        >
                          <BasicDetails
                            {...formProps}
                            fields={fields}
                            values={values}
                            isEdit={isEdit}
                            isSave={isSave}
                            investmentId={intInvestmentId}
                            restrictions={restrictions}
                            {...{ isInnerFormDirty, setIsInnerFormDirty }}
                            setRestrictions={setRestrictions}
                            setTabGrey={setTabGrey}
                            planId={planId}
                            restrictionsList={restrictionsList}
                            masterInvestmentData={formValues}
                          />
                        </Tab>
                      </Tabs>
                    ) : (
                      <Tabs
                        activeKey={keyValue}
                        transition={false}
                        onSelect={tabChange}
                        mountOnEnter
                        unmountOnExit
                      >
                        <Tab
                          eventKey={1}
                          title={
                            <div>
                              <FontAwesomeIcon
                                icon={setTabIcon(1)}
                                color={setTabColor(1)}
                                className={"mr-1"}
                              />
                              <span className="tabName">Basic Details</span>
                            </div>
                          }
                          tabClassName={setTabClass(1)}
                        >
                          <BasicDetails
                            {...formProps}
                            fields={fields}
                            values={values}
                            isEdit={isEdit}
                            isSave={isSave}
                            investmentId={intInvestmentId}
                            restrictions={restrictions}
                            {...{ isInnerFormDirty, setIsInnerFormDirty }}
                            setRestrictions={setRestrictions}
                            setTabGrey={setTabGrey}
                            planId={planId}
                            restrictionsList={restrictionsList}
                            masterInvestmentData={formValues}
                          />
                        </Tab>
                        <Tab
                          eventKey={2}
                          title={
                            <div>
                              <FontAwesomeIcon
                                icon={setTabIcon(2)}
                                color={setTabColor(2)}
                                className={"mr-1"}
                              />
                              <span className="tabName">
                                Clearing Partner Details
                              </span>
                            </div>
                          }
                          tabClassName={setTabClass(2)}
                        >
                          <ClearingPartnerDetails
                            {...formProps}
                            fields={fields}
                            values={values}
                            isEdit={isEdit}
                            isSave={isSave}
                            toggle={toggle}
                            planId={planId}
                            setToggle={setToggle}
                            setTabGrey={setTabGrey}
                          />
                        </Tab>
                        <Tab
                          eventKey={3}
                          title={
                            <div>
                              <FontAwesomeIcon
                                icon={setTabIcon(3)}
                                color={setTabColor(3)}
                                className={"mr-1"}
                              />
                              <span className="tabName">
                                Advisor Representative Details
                              </span>
                            </div>
                          }
                          tabClassName={setTabClass(3)}
                        >
                          <AdvisorRepresentativeDetails
                            {...formProps}
                            fields={fields}
                            values={values}
                            isEdit={isEdit}
                            isSave={isSave}
                            toggle={toggle}
                            planId={planId}
                            setToggle={setToggle}
                            setTabGrey={setTabGrey}
                          />
                        </Tab>
                        {/* <Tab
                          eventKey={3}
                          title={
                            <div>
                              <FontAwesomeIcon
                                icon={setTabIcon(3)}
                                color={setTabColor(3)}
                                className={"mr-1"}
                              />
                              <span className="tabName">Account Balance</span>
                            </div>
                          }
                          tabClassName={setTabClass(3)}
                        >
                           <AccountBalanceComponent />
                        </Tab> */}
                      </Tabs>
                    )}
                  </div>
                </div>
                <DeleteWarning
                  DeleteToastMessageHead={DeleteToastMessageHead}
                  DeleteToastMessage={DeleteToastMessage}
                  showModal={showWarning}
                  handleConfirmClick={handleConfirmClick1}
                  handleCancelClick={handleCancelClick}
                />
                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={handleClose}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <p>{errorMsg}</p>
                        <br />
                        <Button className="cancel-btn" onClick={handleClose}>
                          Ok
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default AddInvestmentContainer;
